import { api } from './configs/axiosConfig';

const endPoint = "/category";

export const categoryAPI = {
    getCategories: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: endPoint,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    },
    getSubCategories: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: `${endPoint}/sub`,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    },
}